import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
    name: "user-infos",
})

export default class UserInfos extends Vue {
    public get date(): Date {
        return this.$store.state.app.now;
    }

    public get userName(): string {
        return this.$store.state.user.account.name;
    }
}
